import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import throttle from 'lodash/throttle';
import { prefetch } from '../../prefetch';
import { performanceNow } from '../../common/utils/performance-now';
import { NAVIGATION_CHANNEL, NavigationAnalyticsContext, OPERATIONAL_EVENT_TYPE, TRIGGER_COMPONENT, TRIGGER_SUBJECT, withAnalyticsEvents } from '../../common/utils/analytics';
import packageContext from '../../common/utils/package-context';
const THROTTLE_EXPIRES = 60 * 1000; // 60 seconds
const THROTTLE_OPTIONS = {
  leading: true,
  trailing: false
};
const TRIGGER_CONTEXT = {
  componentName: TRIGGER_COMPONENT,
  ...packageContext
};
class PrefetchTrigger extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "fireOperationalEvent", payload => {
      if (this.props.createAnalyticsEvent) {
        this.props.createAnalyticsEvent({
          eventType: OPERATIONAL_EVENT_TYPE,
          actionSubject: TRIGGER_SUBJECT,
          ...payload
        }).fire(NAVIGATION_CHANNEL);
      }
    });
    _defineProperty(this, "triggerPrefetch", throttle(() => {
      prefetch(this.props);
      this.fireOperationalEvent({
        action: 'triggered'
      });
    }, THROTTLE_EXPIRES, THROTTLE_OPTIONS));
    _defineProperty(this, "handleMouseEnter", () => {
      this.triggerPrefetch();
      this.lastEnteredAt = performanceNow();
    });
    _defineProperty(this, "handleMouseClick", () => {
      if (this.lastEnteredAt) {
        const hoverToClick = Math.round(performanceNow() - this.lastEnteredAt);
        this.fireOperationalEvent({
          action: 'clicked',
          attributes: {
            hoverToClick
          }
        });
      }
    });
  }
  render() {
    const {
      children,
      Container = 'div'
    } = this.props;
    return /*#__PURE__*/React.createElement(Container, {
      onFocus: this.handleMouseEnter,
      onMouseEnter: this.handleMouseEnter,
      onClick: this.handleMouseClick
    }, children);
  }
}
const PrefetchTriggerWithEvents = withAnalyticsEvents()(PrefetchTrigger);
export default (props => /*#__PURE__*/React.createElement(NavigationAnalyticsContext, {
  data: TRIGGER_CONTEXT
}, /*#__PURE__*/React.createElement(PrefetchTriggerWithEvents, props)));